import styled from 'styled-components';

import React from 'react';
import { useCustomAlert } from '../../context/CustomAlertContext';
import { FaQuestionCircle /*, FaRegQuestionCircle*/ } from 'react-icons/fa';

/* 간단한 정보를 표시하는 Custom Alert 모달창 */
const AlertLabel = ({ label, message }) => {
    const { showAlert } = useCustomAlert();

    return (
        <FlexContainer>
            <span>{label}</span>
            <Icon onClick={() => showAlert(message)} />
        </FlexContainer>
    );
};

export default AlertLabel;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
`;

const Icon = styled(FaQuestionCircle)`
    margin-left: 12px;
    width: 17px;
    height: 17px;
    color: #4b5563;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
        color: #9ca3af;
    }
`;
